export var getHiscoxProfessionalLicenseAttestationSelectList = function getHiscoxProfessionalLicenseAttestationSelectList() {
  return [{
    label: 'Yes',
    value: 'Yes'
  }, {
    label: 'No',
    value: 'No'
  }, {
    label: 'Not Required',
    value: 'Not Required'
  }];
};
export var getHiscoxInsurancePolicyInEffectSelectList = function getHiscoxInsurancePolicyInEffectSelectList() {
  return [{
    label: 'Yes',
    value: 'Yes'
  }, {
    label: 'No',
    value: 'No'
  }, {
    label: 'Prefer not to answer',
    value: 'Prefer not to answer'
  }];
};